import * as React from "react";

import {
  PresentationAddedWishlistItem,
  usePdpAnalytics,
  usePdpWishlistPresentation,
  usePdpWishlistUserExperience,
} from "../providers";

export const StepWishlistAddedFinal: React.FunctionComponent = () => {
  const { handleCloseOfTheRightDrawerAtAnyTime } =
    usePdpWishlistUserExperience();

  const { presentationProducts } = usePdpWishlistPresentation();

  const { analytics } = usePdpAnalytics();

  const header = React.useMemo(() => {
    return (
      <React.Fragment>
        {presentationProducts.length > 1 ? (
          <h2>{`WE ADDED ${presentationProducts.length} ITEMS TO YOUR WISHLIST`}</h2>
        ) : (
          <h2>{`WE ADDED ${presentationProducts.length} ITEM TO YOUR WISHLIST`}</h2>
        )}
      </React.Fragment>
    );
  }, [presentationProducts]);

  const wishlistAdditions = React.useMemo(() => {
    return (
      <ul className="product-list readonly">
        {presentationProducts.map((product) => (
          <StepWishlistAddedFinal_Product key={product.id} product={product} />
        ))}
      </ul>
    );
  }, [presentationProducts]);

  React.useEffect(() => {
    presentationProducts.map((product) => {
      analytics.addToWishlistAction({
        sku: product.sku || "",
        price: product.pricingInformation.productPriceAfter || 0,
        qty: product.quantityWishedToAdd,
        name: product.cart_description || "",
      });
    });
  }, []);

  return (
    <section className="pdp-wishlist step-wishlist-added-final">
      {header}

      {wishlistAdditions}

      <div className="pdp-modal-wishlist-final-step-footer">
        <a href="/wishlist">GO TO WISHLIST</a>
        <button
          onClick={handleCloseOfTheRightDrawerAtAnyTime}
          className="continue-shopping-button"
        >
          CONTINUE SHOPPING
        </button>
      </div>
    </section>
  );
};

interface StepWishlistAddedFinal_ProductProps {
  product: PresentationAddedWishlistItem;
}
const StepWishlistAddedFinal_Product: React.FunctionComponent<
  StepWishlistAddedFinal_ProductProps
> = (props) => {
  const { product } = props;

  const imageSrc = React.useMemo(() => {
    const { thumbnail } = product;
    let itemImageSrc;
    if (thumbnail) {
      itemImageSrc = thumbnail.url;
    }
    return itemImageSrc;
  }, [product]);

  return (
    <li>
      <div className="product">
        <div className="left">
          <div className="product-image-center-alignment-container">
            <div className="product-image-aspect-ratio-container">
              <img className="product-image-photo" src={imageSrc} />
            </div>
          </div>
        </div>
        <div className="right">
          <div className="center-alignment-container">
            <h4 className="title">{product.cart_description || ""}</h4>

            <div
              className={`greater-price-container ${
                product.pricingInformation.productHasMemberPrice
                  ? "has-member-price"
                  : "no-member-price"
              }`}
            >
              {product.pricingInformation.productHasMemberPrice && (
                <div className="member-price-container">
                  <span className="label">{`Members:`}</span>
                  <span className="value">{`$${(
                    product.pricingInformation.productMemberPrice || 0
                  ).toFixed(2)}`}</span>
                </div>
              )}
              <div className="price-box price-final_price">
                {product.pricingInformation.productHasSalesPrice ? (
                  <React.Fragment>
                    <span className="special-price">
                      <span className="price-container price-final_price tax weee">
                        <span className="price-label">Special Price</span>
                        <span
                          id={`product-price-${product.id}`}
                          data-price-amount={(
                            product.pricingInformation.productPriceAfter || 0
                          ).toFixed(2)}
                          data-price-type="finalPrice"
                          className="price-wrapper"
                        >
                          <span className="price">{`$${(
                            product.pricingInformation.productPriceAfter || 0
                          ).toFixed(2)}`}</span>
                        </span>
                      </span>
                    </span>

                    <span className="old-price">
                      <span className="price-container price-final_price tax weee">
                        <span className="price-label">was</span>
                        <span
                          id={`old-price-${product.id}`}
                          data-price-amount={(
                            product.pricingInformation.productPriceBefore || 0
                          ).toFixed(2)}
                          data-price-type="oldPrice"
                          className="price-wrapper"
                        >
                          <span className="price">{`$${(
                            product.pricingInformation.productPriceBefore || 0
                          ).toFixed(2)}`}</span>
                        </span>
                      </span>
                    </span>
                  </React.Fragment>
                ) : (
                  <span className="price-container price-final_price tax weee">
                    <span
                      id={`product-price-${product.id}`}
                      data-price-amount={(
                        product.pricingInformation.productPriceAfter || 0
                      ).toFixed(2)}
                      data-price-type="finalPrice"
                      className="price-wrapper"
                    >
                      <span className="price">{`$${(
                        product.pricingInformation.productPriceAfter || 0
                      ).toFixed(2)}`}</span>
                    </span>
                  </span>
                )}
              </div>
            </div>

            <p className="quantity">
              <span className="static-label">{`Quantity`}&#58;&nbsp;</span>
              <span className="dynamic-value">
                {product.quantityWishedToAdd}
              </span>
            </p>
          </div>
        </div>
      </div>
    </li>
  );
};
